import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="bg-footer-bg main-footer flex flex-col justify-center items-center lg:block lg:px-28 pt-12 pb-12">
          <img src="../img/logo-panelo.png" alt="" />

          <div className="font-nunito flex flex-col lg:flex-row mt-16">
            <div className="contact-us lg:w-3/12 flex flex-col justify-center items-center lg:block">
              <h4 className="text-main-color text-2xl font-bold mb-6 lg:mb-9 lg:mt-0 ">
                CONTACT US
              </h4>
              <ul>
                <li className="flex mb-2 lg:mb-4">
                  <img src="../img/mail.svg" alt="" />
                  <span className="ml-4">Info@Panelo.com</span>
                </li>
                <li className="flex mb-2 lg:mb-4">
                  <img src="../img/hp.svg" alt="" />
                  <span className="ml-4">(021) 080989999</span>
                </li>
                <li className="flex mb-2 lg:mb-4">
                  <img src="../img/home.svg" alt="" />
                  <span className="ml-4">
                    Jakarta, Jalan No.2a, <br /> Indonesia
                  </span>
                </li>
              </ul>
            </div>
            <div className="solution lg:w-3/12 flex flex-col justify-center items-center lg:block">
              <h4 className="text-main-color text-2xl font-bold mt-9 mb-6 lg:mb-9 lg:mt-0  ">
                SOLUTIONS
              </h4>
              <ul className="flex flex-col justify-center items-center lg:block">
                <li className="flex mb-2 lg:mb-4">
                  <a className="hover:text-main-color hover:underline" href="">
                    Panelo Sign
                  </a>
                </li>
                <li className="flex mb-2 lg:mb-4">
                  <a className="hover:text-main-color hover:underline" href="">
                    Panelo CMS
                  </a>
                </li>
                <li className="flex mb-2 lg:mb-4">
                  <a className="hover:text-main-color hover:underline" href="">
                    Panelo Vision
                  </a>
                </li>
              </ul>
            </div>
            <div className="solution lg:w-3/6 flex flex-col justify-center items-center lg:block">
              <h4 className="text-main-color text-2xl font-bold mt-9 mb-6 lg:mb-9 lg:mt-0 ">
                APPLICATIONS
              </h4>
              <div className="flex flex-col lg:flex-row w-full">
                <ul className="flex flex-col justify-center items-center lg:block lg:mr-28">
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Digital Menu Board for TV
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Gym & Fitness
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Retail
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Education
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Religious Venues
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Corporate Office
                    </a>
                  </li>
                </ul>
                <ul className="flex flex-col justify-center items-center lg:block">
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Movie Theaters
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Digital Menu for restaurant
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      QR Code Restaurant Menu
                    </a>
                  </li>
                  <li className="flex mb-2 lg:mb-4">
                    <a
                      className="hover:text-main-color hover:underline"
                      href=""
                    >
                      Health Care
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center lg:block pt-11">
            <ul className="flex justify-center">
              <li className="mr-2">
                <a href="">
                  <img
                    className="hover:translate-x-5"
                    src="../img/fb.svg"
                    alt=""
                  />
                </a>
              </li>
              <li className="mx-2">
                <a href="">
                  <img src="../img/twt.svg" alt="" />
                </a>
              </li>
              <li className="mx-2">
                <a href="">
                  <img src="../img/linkedin.svg" alt="" />
                </a>
              </li>
              <li className="mx-2">
                <a href="">
                  <img src="../img/youtube.svg" alt="" />
                </a>
              </li>
              <li className="mx-2">
                <a href="">
                  <img src="../img/ig.svg" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="font-nunito bg-main-color h-12 flex justify-center items-center">
          <p className="text-white font-bold text-center">
            Panelo &copy; 2021 All Right Reserved
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;
